import { colors, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import numeral from 'numeral';
import { getComparableDateStr } from './DateFilter';

const useStyles = makeStyles((theme) => ({
  igualValue: {
    color: colors.grey[700],
  },
  menorValue: {
    color: colors.red[900],
  },
  maiorValue: {
    color: colors.green[900],
  },
  marginLeft: {
    marginLeft: theme.spacing(1),
  }
}));

export interface KPIComparativoProps {
  valorBase: number;
  valor: number;
  data?: Date;
  display?: KPIComparativoDisplay;
  prefixo?: string;
  format?: string;
}

export enum KPIComparativoDisplay { Full, OnlyPercent, OnlyValue };

export const KPIComparativo = (props: KPIComparativoProps) => {
  const classes = useStyles();
  const {
    format = ',0.00',
    prefixo = props.prefixo ? props.prefixo + " " : "",
    display = KPIComparativoDisplay.Full,
    valor = props.valor ?? 0,
    valorBase = props.valorBase ?? 0,
  } = props;

  var percentualComparativo = valor > 0 ? ((valorBase / valor) * 100) : 0;
  percentualComparativo = percentualComparativo > 0 ? (percentualComparativo - 100) : percentualComparativo;
  const percentualComparativoStr = (percentualComparativo > 0 ? "+" : "") + numeral(percentualComparativo).format(',0') + "%";
  const comparativeDateStr = props.data ? getComparableDateStr(props.data) : ""

  return <>
    <span
      className={percentualComparativo > 0 ? classes.maiorValue : percentualComparativo < 0 ? classes.menorValue : classes.igualValue}
      style={{ fontSize: '0.75rem' }}
    >
      {prefixo +
        (display === KPIComparativoDisplay.OnlyPercent ?
          percentualComparativoStr : display === KPIComparativoDisplay.OnlyValue ?
            numeral(valor).format(format) :
            numeral(valor).format(format) + " (" + percentualComparativoStr + ")")}
    </span>
    {comparativeDateStr && <Typography
      className={classes.marginLeft}
      color="textSecondary"
      variant="caption"
    >
      {comparativeDateStr}
    </Typography>}
  </>
}

